/* eslint-disable import/prefer-default-export */

export const CONFIRM_CHANGED = 'CONFIRM_CHANGED';

export const TICKET_GROUPS_CHANGED = 'TICKET_GROUPS_CHANGED';

export const PROMO_CODE_CHANGED = 'PROMO_CODE_CHANGED';
export const PROMO_CODE_NAME_CHANGED = 'PROMO_CODE_NAME_CHANGED';
export const PROMO_CODE_NAME_VALID_CHANGED = 'PROMO_CODE_NAME_VALID_CHANGED';

export const REVEALED_HOLD_CHANGED = 'REVEALED_HOLD_CHANGED';

export const CHOOSING_TICKET_TYPES = 'CHOOSING_TICKET_TYPES';
export const CHOOSING_ADD_ONS = 'CHOOSING_ADD_ONS';
export const CHOOSING_DONATION = 'CHOOSING_DONATION';
export const CHOOSING_MEMBERSHIP = 'CHOOSING_MEMBERSHIP';

export const STRIPE_PROMISE_CHANGED = 'STRIPE_PROMISE_CHANGED';
export const STRIPE_ERROR_CHANGED = 'STRIPE_ERROR_CHANGED';
export const TICKET_TYPES_CHANGED = 'TICKET_TYPES_CHANGED';
export const ADD_ONS_CHANGED = 'ADD_ONS_CHANGED';
export const TICKET_RESERVATION_CHANGED = 'TICKET_RESERVATION_CHANGED';
export const CANCEL_CHECKOUT = 'CANCEL_CHECKOUT';
export const CHECKOUT_TIME_PERCENTAGE_REMAINING_CHANGED = 'CHECKOUT_TIME_PERCENTAGE_REMAINING_CHANGED';
export const TIME_LIMIT_REACHED_CHANGED = 'TIME_LIMIT_REACHED_CHANGED';
export const IS_PLACING_ORDER_CHANGED = 'IS_PLACING_ORDER_CHANGED';
export const GTAG_CHANGED = 'GTAG_CHANGED';
export const CUSTOM_FIELD_VALUE_CHANGED = 'CUSTOM_FIELD_VALUE_CHANGED';

export const SEATS_IO_CHART_CHANGED = 'SEATS_IO_CHART_CHANGED';
export const SEATS_IO_SELECTED_OBJECTS_CHANGED = 'SEATS_IO_SELECTED_OBJECTS_CHANGED';
export const CUSTOMERIO_ID_CHANGED = 'CUSTOMERIO_ID_CHANGED';
export const PARENT_URL_CHANGED = 'PARENT_URL_CHANGED';
export const ORIGIN_ATTRIBUTION_CHANGED = 'ORIGIN_ATTRIBUTION_CHANGED';
export const META_CLICK_ID_CHANGED = 'META_CLICK_ID_CHANGED';
export const ATTRIBUTION_VISITOR_CHANGED = 'ATTRIBUTION_VISITOR_CHANGED';
export const IS_CREATING_TICKET_RESERVATION_CHANGED = 'IS_CREATING_TICKET_RESERVATION_CHANGED';
export const CART_START_BUSY_MESSAGE_CHANGED = 'CART_START_BUSY_MESSAGE_CHANGED';

export const INSURANCE_OFFER_STATE_CHANGED = 'INSURANCE_OFFER_STATE_CHANGED';
export const TICKET_INSURANCE_CHANGED = 'TICKET_INSURANCE_CHANGED';
export const HAS_INSURANCE_QUOTE_CHANGED = 'HAS_INSURANCE_QUOTE_CHANGED';
export const DONATION_CUSTOM_CHARGE_TYPE_CHANGED = 'DONATION_CUSTOM_CHARGE_TYPE_CHANGED';
export const USER_CONTEXT_CHANGED = 'USER_CONTEXT_CHANGED';

export const MEMBERSHIP_PRODUCTS_CHANGED = 'MEMBERSHIP_PRODUCTS_CHANGED';
export const SELECTED_MEMBERSHIP_PRODUCT_CHANGED = 'SELECTED_MEMBERSHIP_PRODUCT_CHANGED';

export const WIDGET_CONFIG_REPLACED = 'WIDGET_CONFIG_REPLACED';
export const CHECKOUT_CATEGORIES_REPLACED = 'CHECKOUT_CATEGORIES_REPLACED';
export const RESALE_LISTINGS_FETCHED = 'RESALE_LISTINGS_FETCHED';
export const RESALE_QUANTITY_CHANGED = 'RESALE_QUANTITY_CHANGED';
